import CSVButton from '../CSVButton'
import ActionButton from '../ActionButton'
import { addErrorSDKToast } from 'src/utils/helpers'
import { Emoji, NormalizedParticipant } from 'src/app/types'
import { FC } from 'react'
import {useCreateCsv, useGetRunningContext} from 'src/hooks'

type LeaderboardFooterProps = {
  headers: Emoji[]
  normalizedParticipants: NormalizedParticipant[]
}

const LeaderboardFooter: FC<LeaderboardFooterProps> = ({
  headers,
  normalizedParticipants,
}) => {
  const { isLoading, onExportToCSV } = useCreateCsv({
    allBadges: headers,
    normalizedParticipants,
    name: 'Leaderboard',
  })

  const onShareResult = () => {
    try {
      window.zoomSdk.shareApp({ action: 'start' })
    } catch (error) {
      addErrorSDKToast(error)
    }
  }

  const { isLoading: isContextLoading, runningContext } = useGetRunningContext()

  return (
    <div className="inline-flex justify-end fixed w-full sm:w-mainView right-0 bottom-0 bg-white p-4 z-40">
        { !isContextLoading && runningContext === 'inMeeting' && (
            <>
                <ActionButton
                    type="secondary"
                    padding="lg"
                    ariaLabel="Share Results"
                    onClick={onShareResult}
                    styles="w-[123px] mr-2"
                >
                    Share Results
                </ActionButton>
            </>
        )}


      <CSVButton
        isLoading={isLoading}
        onExportToCSV={onExportToCSV}
        disabled={normalizedParticipants.length <= 0}
      />
    </div>
  )
}

export default LeaderboardFooter
